exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-3c038848] .v-divider {\n  border-color: gray;\n  margin: 0px;\n}\n[data-v-3c038848] .v-card .v-card-title {\n  color: #585f69 !important;\n  margin: 0 0 -2px 0 !important;\n  padding-right: 10px !important;\n  display: inline-block !important;\n  text-shadow: 0 0 1px #f6f6f6 !important;\n  border-bottom: 2px solid #29bf12 !important;\n}\n", ""]);

// exports
